export const videos = {
    master_link: 'https://drive.google.com/drive/folders/11dInIEntTBoOP5EJ8YjCcIoYhPAbLuli?usp=drive_link',
    videos_list: [
        {
            chapter_title: 'Chapter 1',
            chapter_link: 'https://drive.google.com/drive/folders/1C6SBPa6okwfvwK8ruVW8fXBJImMhjn-9?usp=drive_link',
            chapter_name: 'Concepts of Economics',
            tutorials: [
                'https://drive.google.com/file/d/1C1CT7WWXsI3nTDueqIHr7LsINHkTeK37/view?usp=drive_link',
                'https://drive.google.com/file/d/1XeDGxIV-HCoPG2ZvXO4045V_jE1xvETO/view?usp=drive_link',
                'https://drive.google.com/file/d/1Qr--cxiBlc8gObgHb5hnKJptoIPi70Hl/view?usp=drive_link'
            ],
            courses: [
                'https://drive.google.com/file/d/17Jq9FisFsYfZ8VLc43Yj5qMfRikHUN4G/view?usp=drive_link',
                'https://drive.google.com/file/d/1cRp1XroPsHnD1tXNBJOlnnNX7_Zm1YHM/view?usp=drive_link',
                'https://drive.google.com/file/d/1kxNeq-JG640UyfxyzOXDsCpWZlL5Csht/view?usp=drive_link',
            ]
        },
        {
            chapter_title: 'Chapter 2',
            chapter_link: 'https://drive.google.com/drive/folders/1V84FNrrFKqPUBZ-xRbygED_jygKYRVC-?usp=drive_link',
            chapter_name: 'Overview of the Enterprise',
            tutorials: [
                "https://drive.google.com/file/d/1LFZ9f4O8bUvIk0DgEbL5oZJLgFaoPEN-/view?usp=drive_link"
            ],
            courses: [
                'https://drive.google.com/file/d/1h3seGncz1t8K5Tr5nX5sqYAcSIUopWLe/view?usp=drive_link',
                'https://drive.google.com/file/d/160VAD6bZ9hTIvyPXQtfIo8_Vq9degTha/view?usp=drive_link',
                'https://drive.google.com/file/d/1wF--ZnTtZsoAVW5Eoe9wmuQt9OXSeYnU/view?usp=drive_link',
                'https://drive.google.com/file/d/1cpfhLGS1ay7wbHKfm0nZEDboNFWjMHRL/view?usp=drive_link',
                'https://drive.google.com/file/d/15ZqrQfvOS0VJOJNwMAo4gde6kyLDgkqv/view?usp=drive_link',
                'https://drive.google.com/file/d/16ZEBdiCG9Rp_xumNAgbzrniHcxMnJNiM/view?usp=drive_link',
                'https://drive.google.com/file/d/1WfUMaR8WugIB-xe-nm2XZNK1Vh86WbDz/view?usp=drive_link'
            ]
        },
        {
            chapter_title: 'Chapter 3',
            chapter_link: 'https://drive.google.com/drive/folders/1httpXfepxge4Wv5KHsR8dloCHYG1qaDV?usp=drive_link',
            chapter_name: 'The Production Function',
            tutorials: [
                'https://drive.google.com/file/d/170yjAEXjIriXovnin0gTbnO1cyBsM2T-/view?usp=drive_link',
                'https://drive.google.com/file/d/1sF-MRTtn3VRyY32acCv2aW9hhQcbTl66/view?usp=drive_link',
                'https://drive.google.com/file/d/1Q_3sUkfHQxxc_UxuIFBsdumnG6aFC_L9/view?usp=drive_link'
            ],
            courses: [
                'https://drive.google.com/file/d/1zfARbaoF4Q_rK5h_YT-SavdrC2KhN3HQ/view?usp=drive_link',
                'https://drive.google.com/file/d/1EQ9rb8ULcqENcduE_LjL6HvoCextTXBj/view?usp=drive_link',
                'https://drive.google.com/file/d/1-e-uyojSnDcm8f1JkRFFFve-JEeY99Bd/view?usp=drive_link',
                'https://drive.google.com/file/d/1lCbus8ewUZhCEHb76NNyQsvALxdyPh0E/view?usp=drive_link',
                'https://drive.google.com/file/d/1CmipnIUUtLIEbyJuPI-MHqilXyJBif0N/view?usp=drive_link'
            ]
        },
        {
            chapter_title: 'Chapter 4',
            chapter_link: 'https://drive.google.com/drive/folders/1lSRCc4PzjoHlsrLYgv6lC8UeiWJT0aVw?usp=drive_link',
            chapter_name: 'The Finance Function',
            tutorials: [
                'https://drive.google.com/file/d/1zYwIK4ootWeHCFzzniaMarvdbDsuaFBK/view?usp=drive_link',
                'https://drive.google.com/file/d/1EPIwZBdBT4QCyWtIH2xEL9wDBLmcXbnP/view?usp=drive_link'
            ],
            courses: [
                'https://drive.google.com/file/d/1YiGM9OFpRdb2RT4s2SeaufdlC4TnJPvF/view?usp=drive_link',
                'https://drive.google.com/file/d/1_aq7t2hnuuN8UEXwM7F1GRlLMgKGF2Ef/view?usp=drive_link',
                'https://drive.google.com/file/d/1JXbZ93SRBvE4RYi3oxsRL7gDud5PKO2Z/view?usp=drive_link',
                'https://drive.google.com/file/d/1Et5kmtdddgfigqtNMctL9_nocmmYi0av/view?usp=drive_link',
                'https://drive.google.com/file/d/119OpngFhpl0PILyOjkp70byg5rMLuNZ4/view?usp=drive_link',
                'https://drive.google.com/file/d/1V22-U7RHf0KvWRwUtvS62QkvQ-1Zu4_8/view?usp=drive_link'
            ]
        }
    ]
}